import { HttpRequest } from "../utils";
import { downloadFile, openFileInNewTab } from "../utils/file-download";
import type {
  PlatformInvoice,
  InvoiceListParams,
  InvoiceListResult,
  InvoiceSummary
} from "./platformInvoice";

const httpRequest = new HttpRequest();

export type { PlatformInvoice, InvoiceListParams, InvoiceListResult, InvoiceSummary };

/** GET /bil/my/invoices — returns { rows, total, page, limit, summary }. */
export const listMy = (params?: InvoiceListParams) =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  httpRequest.get("/bil/my/invoices", params as any);

/** Open a tenant invoice PDF inline in a new tab. */
export const openInvoicePdf = (id: string) =>
  openFileInNewTab(`/bil/my/invoices/${id}/pdf`);

/** Download the tenant's invoices as CSV, honouring the current list filters. */
export const exportInvoicesCsv = (params?: Pick<InvoiceListParams, "status" | "year" | "search" | "fromDate" | "toDate">) =>
  downloadFile(
    "/bil/my/invoices/export",
    `invoices-${new Date().toISOString().slice(0, 10)}.csv`,
    params
  );
